import { Input, InputProps } from '@chakra-ui/react';
import { UseFormReturn, FieldPath } from 'react-hook-form';

type Props<TFieldValues> = InputProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const CrawlerNameInput = <TFieldValues,>({
  name,
  register,
  ...inputProps
}: Props<TFieldValues>) => (
  <Input
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: 'クローラー名は255文字以内にする必要があります。',
      },
    })}
    {...inputProps}
  />
);
